import { useEffect } from "react";

import type { NotificationSubject } from "simplydo/core/api/notifications";

import api from "api";
import { useCurrentUser } from "utils/currentUser";

export const useClearNotifications = (
  subject: NotificationSubject,
  id: string | null | undefined,
) => {
  const userId = useCurrentUser()?._id;

  useEffect(() => {
    if (!userId || !id) return;
    api.notifications.markSubjectAsInteracted(
      subject,
      id,
      ({ modified }) => {
        if (modified > 0) {
          api.invalidateQueries(api.notifications.get);
          api.invalidateQueries(api.users.dashboard);
        }
      },
      () => {},
    );
  }, [subject, id, userId]);
};
